/**
 * Shared JSON Schema fragments for WebMCP tools.
 * Includes defaults and examples so inspectors (e.g. Model Context Tool Inspector)
 * pre-fill valid hex colors instead of generic "example_string" placeholders.
 */

const HEX_PATTERN = '^#?[0-9A-Fa-f]{6}$';

export const hexColorSchema = (example: string) => ({
  type: 'string' as const,
  pattern: HEX_PATTERN,
  description: `Six-digit hex color with optional # prefix (e.g. ${example})`,
  default: example,
  examples: [example],
});

export const CHECK_CONTRAST_INPUT_SCHEMA = {
  type: 'object' as const,
  properties: {
    foreground: hexColorSchema('#333333'),
    background: hexColorSchema('#FFFFFF'),
    standard: {
      type: 'string' as const,
      enum: ['wcag2', 'apca'] as const,
      default: 'wcag2',
      description:
        'Primary contrast standard to emphasize. Both WCAG 2.1 and APCA results are always returned.',
    },
  },
  required: ['foreground', 'background'] as const,
  additionalProperties: false,
};

export const BASE_COLOR_INPUT_SCHEMA = {
  type: 'object' as const,
  properties: {
    baseColor: hexColorSchema('#2563EB'),
    mode: {
      type: 'string' as const,
      enum: ['light', 'dark'] as const,
      default: 'light',
      description: 'Color appearance mode. Defaults to light.',
    },
    formula: {
      type: 'string' as const,
      enum: ['wcag2', 'wcag3'] as const,
      default: 'wcag2',
      description:
        'Contrast formula: wcag2 for WCAG 2.1 ratios, wcag3 for APCA Lc values. Defaults to wcag2.',
    },
  },
  required: ['baseColor'] as const,
  additionalProperties: false,
};

export const LEONARDO_URL_INPUT_SCHEMA = {
  type: 'object' as const,
  properties: {
    ...BASE_COLOR_INPUT_SCHEMA.properties,
    themeName: {
      type: 'string' as const,
      default: 'Color Scales I/O',
      description: 'Display name for the Leonardo theme. Defaults to "Color Scales I/O".',
    },
  },
  required: ['baseColor'] as const,
  additionalProperties: false,
};
